import React from 'react';
import AppContext from '~/context/AppContext';
import AvatarExamineeView, { AvatarExamineeViewProps } from './AvatarExamineeView';
export interface AvatarExamineeProps {
  size?: AvatarExamineeViewProps['size'];
}
export const AvatarExaminee: React.FC<AvatarExamineeProps> = ({
  size
}: AvatarExamineeProps): React.ReactElement<AvatarExamineeProps> => {
  const {
    state
  } = React.useContext(AppContext);
  return <AvatarExamineeView isLoading={state.examineePhotoIsLoading} size={size} src={state.examineePhotoSrc} data-sentry-element="AvatarExamineeView" data-sentry-component="AvatarExaminee" data-sentry-source-file="index.tsx" />;
};
export default AvatarExaminee;